import React, { useEffect } from 'react';
import '../styles/Home.css'
import Header from '../components/Header.jsx'
import Sliders from '../components/Sliders.jsx'
import img1 from '../assets/cruise-ship.jpg'
import img2 from '../assets/student-loan.avif'
import img3 from '../assets/production-line-crop.jpg'
import img4 from '../assets/scholarships.jpg'
import img5 from '../assets/travel.jpg'
import Partners from '../components/Partners.jsx';
import About from '../components/About.jsx';
import Services from '../components/Services.jsx';
import Contact from '../components/Contact.jsx';
import Footer from '../components/Footer.jsx';
import Map from '../components/Map.jsx';
import WA from '../components/WA.jsx';

const slide_images = [
  {
    url: img1,
    alt: 'cruise-ship',
    title: 'Cruise Ship Jobs – Careers on the High Seas',
    body: 'Dream of working on a cruise ship? WASA recruits for international cruise lines with premium career opportunities.',
    ctaTxt: 'Apply Now',
    link: 'https://forms.gle/HyLeLdQfezTJV9fC8'
  },
  {
    url: img2,
    alt: 'education-loan',
    title: 'Educational Loans – Study Now, Pay Later',
    body: 'WASA partners with international financiers to offer loans for postgraduate studies covering tuition, airfare, living expenses, and more.',
    ctaTxt: 'Apply Today',
    link: 'https://forms.gle/GirbhnEghStmtT5e6'
  },
  {
    url: img3,
    alt: 'europe-jobs',
    title: 'Europe Jobs –Blue Collar Work Opportunities',
    body: 'Looking for factory jobs in Europe? WASA has blue-collar opportunities in Germany, Poland, Norway, Czech Republic, and Serbia.',
    ctaTxt: 'Learn More',
    link: 'https://work-and-study-abroad.bookafy.com'
  },
  {
    url: img4,
    alt: 'scholarships',
    title: 'Scholarships in China, India & Malaysia',
    body: 'Apply for scholarships for undergraduate and postgraduate studies. Full and partial tuition coverage available.',
    ctaTxt: 'Learn More',
    link: 'https://rebrand.ly/wasamw'
  },
  {
    url: img5,
    alt: 'general-services',
    title: 'General Services – Making Travel Easier',
    body: 'Visa appointments, flight booking, career guidance, ATS-compliant resumes, and interview training.',
    ctaTxt: 'Learn More',
    link: 'https://rebrand.ly/wasamw'
  }
];

export default function Home() {
  useEffect(() => {
    const handleSmoothScroll = (event) => {
      if (event.target.tagName === 'A' && event.target.hash !== '') {
        event.preventDefault();
        const targetId = event.target.hash.substring(1);
        const targetElement = document.getElementById(targetId);
        if (targetElement) {
          targetElement.scrollIntoView({ behavior: 'smooth' });
        }
      }
    };

    document.addEventListener('click', handleSmoothScroll);

    return () => {
      document.removeEventListener('click', handleSmoothScroll);
    };
  }, []);

  return (
    <main>
        <Header />
        <section className="slide-container">
          <Sliders images={slide_images} />
        </section>
        
        <section className="partners-section">
          <Partners />
        </section>
        
        <About />
        
        <Services />
        
        <section className="start-now">
          <div className="start-now-content">
            <h2>Start Your Journey</h2>
            <h1>Now</h1>
            <a href="https://rebrand.ly/wasamw" target="_blank" rel="noreferrer" className="start-now-cta">
              Get Started
            </a>
          </div>
        </section>
        
        <span id="contact">
          <Contact />
        </span>
        
        <Map />
        <Footer />
        <WA />
    </main>
  );
}